module.exports = __webpack_public_path__ + "img/delete.f4365aae.svg";